import {
  allowEngAud,
  consentEngAud,
  consentLangSelectEngAud,
  covidEngAud,
  healthQuestionEngAud,
  miscellEngAud,
  nonUlipEngAud,
  policyEngAud,
  psmEngAud,
  rpsaleEngAud,
  videoConsentStartRecordEngAud,
  takePhotoEngAud,
  ulipEngAud,
  welcomeEngAud,
  proposalVerificationEngAud,
  videoVerficationEngAud,
  videoConsentEngAug,
  readContentAloudEngAud,
} from "../audios/engAudios";
import {
  allowHinAud,
  consentHinAud,
  consentLangSelectHinAud,
  covidHinAud,
  healthQuestionHinAud,
  miscellHinAud,
  nonUlipHinAud,
  proposalVerificationHinAud,
  policyHinAud,
  preferredLangAud,
  psmHinAud,
  rpsaleHinAud,
  videoConsentStartRecordHinAud,
  takePhotoHinAud,
  ulipHinAud,
  welcomeHinAud,
  videoVerficationHinAud,
  readContentAloudHinAud,
  videoConsentHinAug,
} from "../audios/hindiAudios";
import {
  ulipBengaliAud,
  nonUlipBengaliAud,
  proposalVerificationBengaliAud,
  videoVerficationBengaliAud,
  videoConsentStartRecordBengaliAud,
  readContentAloudBengaliAud,
  videoConsentBengaliAug,
} from "../audios/bengaliAudios";
import {
  ulipPunjabiAud,
  nonUlipPunjabiAud,
  proposalVerificationPunjabiAud,
  videoVerficationPunjabiAud,
  videoConsentStartRecordPunjabiAud,
  readContentAloudPunjabiAud,
  videoConsentPunjabiAug,
} from "../audios/punjabiAudios";
import {
  ulipTeluguAud,
  nonUlipTeluguAud,
  proposalVerificationTeluguAud,
  videoVerficationTeluguAud,
  videoConsentStartRecordTeluguAud,
  readContentAloudTeluguAud,
  videoConsentTeluguAug,
} from "../audios/teluguAudios";
import {
  ulipMarathiAud,
  nonUlipMarathiAud,
  proposalVerificationMarathiAud,
  videoVerficationMarathiAud,
  videoConsentStartRecordMarathiAud,
  readContentAloudMarathiAud,
  videoConsentMarathiAug,
} from "../audios/marathiAudios";
import {
  ulipGujaratiAud,
  nonUlipGujaratiAud,
  proposalVerificationGujaratiAud,
  videoVerficationGujaratiAud,
  videoConsentStartRecordGujaratiAud,
  readContentAloudGujaratiAud,
  videoConsentGujaratiAug,
} from "../audios/gujaratiAudios";
import {
  ulipKannadaAud,
  nonUlipKannadaAud,
  proposalVerificationKannadaAud,
  videoVerficationKannadaAud,
  videoConsentStartRecordKannadaAud,
  readContentAloudKannadaAud,
  videoConsentKannadaAug,
} from "../audios/kannadaAudios";
import {
  ulipMalayalamAud,
  nonUlipMalayalamAud,
  proposalVerificationMalayalamAud,
  videoVerficationMalayalamAud,
  videoConsentStartRecordMalayalamAud,
  readContentAloudMalayalamAud,
  videoConsentMalayalamAug,
} from "../audios/malayalamAudios";
import {
  ulipTamilAud,
  nonUlipTamilAud,
  proposalVerificationTamilAud,
  videoVerficationTamilAud,
  videoConsentStartRecordTamilAud,
  readContentAloudTamillAud,
  videoConsentTamilAug,
} from "../audios/tamilAudios";
import {
  ulipAssameseAud,
  nonUlipAssameseAud,
  proposalVerificationAssameseAud,
  videoVerficationAssameseAud,
  videoConsentStartRecordAssAud,
  readContentAloudAssAud,
  videoConsentAssAug,
} from "../audios/assameseAudios";
import {
  nonUlipUrduAud,
  proposalVerificationUrduAud,
  readContentAloudUrduAud,
  ulipUrduAud,
  videoConsentStartRecordUrduAud,
  videoConsentUrduAug,
  videoVerficationUrduAud,
} from "../audios/urduAudios";
import {
  nonUlipManipuriAud,
  proposalVerificationManipuriAud,
  readContentAloudManipuriAud,
  ulipManipuriAud,
  videoConsentManipuriAug,
  videoConsentStartRecordManipuriAud,
  videoVerficationManipuriAud,
} from "../audios/manipuriAudios";
import {
  nonUlipBhojpuriAud,
  ulipBhojpuriAud,
  proposalVerificationBhojpuriAud,
  videoVerficationBhojpuriAud,
  videoConsentStartRecordBhojpuriAud,
  readContentAloudBhojpuriAud,
  videoConsentBhojpuriAug,
} from "../audios/bhojpuriAudios";
import {
  nonUlipOdiyaAud,
  proposalVerificationOdiyaAud,
  readContentAloudOdiyaAud,
  ulipOdiyaAud,
  videoConsentOdiyaAug,
  videoConsentStartRecordOdiyaAud,
  videoVerficationOdiyaAud,
} from "../audios/odiyaAudios";

export const engConsentDeclaration =
  "I have filled form myself and have clearly understood all the features, terms and conditions before deciding to purchase this insurance policy. I have to pay the premium Rs. 10,000 for 5 years for this policy. I give consent for further processing of my application. This  insurance product features including Terms and Conditions have also been explained and agreed with the life insured of this policy as well.";
export const hinConsentDeclaration =
  "मैंने यह फॉर्म स्वयं भरा है और इस बीमा पॉलिसी की सभी विशेषताओं, नियमों और शर्तों को स्पष्ट समझने के बाद खरीदने का निर्णय लिया है। मुझे इस पॉलिसी के लिए 5 वर्षों तक Rs. 10.000 प्रीमियम चुकाना होगा। मैं अपने आवेदन प्रक्रिया पूरी करने की सहमति देता/ देती हूँ। बीमा पॉलिसी की सुविधाओं नियमों और शर्तों को बीमित व्यक्ति को भी समझाया गया है और इस पॉलिसी के बीमित व्यक्ति के साथ भी सहमति व्यक्त की गई है।";

const playHindiAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudHinAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentHinAug);
      return;
    case "videoverification":
      playAudio(id, videoVerficationHinAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationHinAud);
      return;
    case "langselect":
      playAudio(id, preferredLangAud);
      return;
    case "consentlangselect":
      playAudio(id, consentLangSelectHinAud);
      return;
    case "welcome":
      playAudio(id, welcomeHinAud);
      return;
    case "selfie":
      playAudio(id, takePhotoHinAud);
      return;
    case "product":
      playAudio(id, policyHinAud);
      return;
    case "health-1":
    case "health-2":
      playAudio(id, healthQuestionHinAud);
      return;
    case "psm":
    case "irp":
      playAudio(id, psmHinAud);
      return;
    case "rpsales":
      playAudio(id, rpsaleHinAud);
      return;
    case "covid":
      playAudio(id, covidHinAud);
      return;
    case "miscellaneous":
      playAudio(id, miscellHinAud);
      return;
    case "permission":
      playAudio(id, allowHinAud);
      return;
    case "consent":
      playAudio(id, consentHinAud);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordHinAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipHinAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipHinAud);
      return;

    default:
      break;
  }
};
const playEngAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudEngAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentEngAug);
      return;
    case "videoverification":
      playAudio(id, videoVerficationEngAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationEngAud);
      return;
    case "langselect":
      playAudio(id, preferredLangAud);
      return;
    case "consentlangselect":
      playAudio(id, consentLangSelectEngAud);
      return;
    case "welcome":
      playAudio(id, welcomeEngAud);
      return;
    case "selfie":
      playAudio(id, takePhotoEngAud);
      return;
    case "product":
      playAudio(id, policyEngAud);
      return;
    case "health-1":
    case "health-2":
      playAudio(id, healthQuestionEngAud);
      return;
    case "psm":
    case "irp":
      playAudio(id, psmEngAud);
      return;
    case "rpsales":
      playAudio(id, rpsaleEngAud);
      return;
    case "covid":
      playAudio(id, covidEngAud);
      return;
    case "miscellaneous":
      playAudio(id, miscellEngAud);
      return;
    case "permission":
      playAudio(id, allowEngAud);
      return;
    case "consent":
      playAudio(id, consentEngAud);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordEngAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipEngAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipEngAud);
      return;
    default:
      break;
  }
};

const playBengaliAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudBengaliAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentBengaliAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordBengaliAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationBengaliAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationBengaliAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipBengaliAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipBengaliAud);
      return;
    default:
      break;
  }
};

const playPunjabiAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudPunjabiAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentPunjabiAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordPunjabiAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationPunjabiAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationPunjabiAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipPunjabiAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipPunjabiAud);
      return;
    default:
      break;
  }
};

const playTeluguAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudTeluguAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentTeluguAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordTeluguAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationTeluguAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationTeluguAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipTeluguAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipTeluguAud);
      return;
    default:
      break;
  }
};

const playMarathiAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudMarathiAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentMarathiAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordMarathiAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationMarathiAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationMarathiAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipMarathiAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipMarathiAud);
      return;
    default:
      break;
  }
};

const playGujaratiAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudGujaratiAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentGujaratiAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordGujaratiAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationGujaratiAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationGujaratiAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipGujaratiAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipGujaratiAud);
      return;
    default:
      break;
  }
};
const playUrduAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudUrduAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentUrduAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordUrduAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationUrduAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationUrduAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipUrduAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipUrduAud);
      return;
    default:
      break;
  }
};

const playManipuriAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudManipuriAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentManipuriAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordManipuriAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationManipuriAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationManipuriAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipManipuriAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipManipuriAud);
      return;
    default:
      break;
  }
};

const playBhojpuriAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudBhojpuriAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentBhojpuriAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordBhojpuriAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationBhojpuriAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationBhojpuriAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipBhojpuriAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipBhojpuriAud);
      return;
    default:
      break;
  }
};

const playOdiyaAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudOdiyaAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentOdiyaAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordOdiyaAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationOdiyaAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationOdiyaAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipOdiyaAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipOdiyaAud);
      return;
    default:
      break;
  }
};

const playAssameseAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudAssAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentAssAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordAssAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationAssameseAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationAssameseAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipAssameseAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipAssameseAud);
      return;
    default:
      break;
  }
};

const playKannadaAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudKannadaAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentKannadaAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordKannadaAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationKannadaAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationKannadaAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipKannadaAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipKannadaAud);
      return;
    default:
      break;
  }
};

const playMalayalamAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudMalayalamAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentMalayalamAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordMalayalamAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationMalayalamAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationMalayalamAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipMalayalamAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipMalayalamAud);
      return;
    default:
      break;
  }
};

const playTamilAudio = (id, page) => {
  switch (page.toLowerCase()) {
    case "readcontentaloud":
      playAudio(id, readContentAloudTamillAud);
      return;
    case "videoconsent":
      playAudio(id, videoConsentTamilAug);
      return;
    case "startrecord":
      playAudio(id, videoConsentStartRecordTamilAud);
      return;
    case "videoverification":
      playAudio(id, videoVerficationTamilAud);
      return;
    case "proposallanguageselected":
      playAudio(id, proposalVerificationTamilAud);
      return;
    case "uliplangselectionpage":
      playAudio(id, ulipTamilAud);
      return;
    case "nonuliplangselectionpage":
      playAudio(id, nonUlipTamilAud);
      return;
    default:
      break;
  }
};

export const playVoiceOver = (id, page, lang = "") => {
  // const lngs = ['eng', 'Marathi', 'Bengali', 'Punjabi', 'Telugu']
  let language = localStorage.getItem("LanguageSelected");

  // if (lngs.includes(language) || lngs.includes(lang)) {
  if (lang == "hin" || language == "hin") {
    playHindiAudio(id, page);
  } else if (lang == "Bengali" || language == "Bengali") {
    playBengaliAudio(id, page);
  } else if (lang == "Punjabi" || language == "Punjabi") {
    playPunjabiAudio(id, page);
  } else if (lang == "Telugu" || language == "Telugu") {
    playTeluguAudio(id, page);
  } else if (lang == "Marathi" || language == "Marathi") {
    playMarathiAudio(id, page);
  } else if (lang == "Gujarati" || language == "Gujarati") {
    playGujaratiAudio(id, page);
  } else if (lang == "Kannada" || language == "Kannada") {
    playKannadaAudio(id, page);
  } else if (lang == "Malayalam" || language == "Malayalam") {
    playMalayalamAudio(id, page);
  } else if (lang == "Tamil" || language == "Tamil") {
    playTamilAudio(id, page);
  } else if (lang == "Assamese" || language == "Assamese") {
    playAssameseAudio(id, page);
  } else if (lang == "Bhojpuri" || language == "Bhojpuri") {
    playBhojpuriAudio(id, page);
  } else if (lang == "Urdu" || language == "Urdu") {
    playUrduAudio(id, page);
  } else if (lang == "Odiya" || language == "Odiya") {
    playOdiyaAudio(id, page);
  } else if (lang == "Manipuri" || language == "Manipuri") {
    playManipuriAudio(id, page);
  } else {
    playEngAudio(id, page);
  }
};

// export const playVoiceOver = (id, page) => {
//     let lang = localStorage.getItem('LanguageSelected')
//     if (lang == 'eng') {
//         playEngAudio(id, page)
//     } else {
//         playHindiAudio(id, page)
//     }
// }

const playAudio = (id, audioSource) => {
  let audioEl = document.getElementById(id);
  audioEl.src = audioSource;
  audioEl.play();
};

export const stopAudio = (id) => {
  let audioEl = document.getElementById(id);

  if (audioEl) {
    audioEl.pause();
  }
};

export const endAudios = (id, setEndAudioBtn) => {
  let audioEl = document.getElementById(id);
  audioEl.onended = function () {
    setEndAudioBtn(true);
  };
};

export const muteAudio = (id) => {
  let audioEl = document.getElementById(id);
  if (audioEl) {
    audioEl.muted = true;
  }
};

export const getUserLang = () => {
  const lang = localStorage.getItem("LanguageSelected");
  if(lang === "eng") {
    return "English";
  } else if (lang === "hin") {
    return "Hindi";
  }
  return lang;
};
